// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.5 3.5H13.5M2.5 8H4.75M2.5 12.5H4.75',
  'M9.34 9.34L7.42 9.34L7.42 6.67M7.66 9.34C8.13 8.21 9.24 7.42 10.54 7.42C12.26 7.42 13.66 8.82 13.66 10.54C13.66 12.26 12.26 13.66 10.54 13.66C9.15 13.66 7.98 12.75 7.57 11.5',
];
